// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/assets/fonts/yekanbakh/YekanBakhFaNum-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/assets/fonts/yekanbakh/YekanBakhFaNum-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/assets/fonts/yekanbakh/YekanBakhFaNum-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/assets/fonts/yekanbakh/YekanBakhFaNum-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/assets/fonts/yekanbakh/YekanBakhFaNum-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/assets/fonts/poppins/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../public/assets/fonts/poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.15 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 450px) {

  .container {
    max-width: 450px;
  }
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.static {
  position: static;
}
.absolute {
  position: absolute;
}
.\\!top-\\[30vh\\] {
  top: 30vh !important;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.block {
  display: block;
}
.flex {
  display: flex;
}
.hidden {
  display: none;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[32px\\] {
  height: 32px;
}
.\\!w-80 {
  width: 20rem !important;
}
.w-\\[69px\\] {
  width: 69px;
}
.w-\\[86px\\] {
  width: 86px;
}
.w-full {
  width: 100%;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.resize {
  resize: both;
}
.flex-col {
  flex-direction: column;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-4 {
  gap: 1rem;
}
.border {
  border-width: 1px;
}
.p-4 {
  padding: 1rem;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
@font-face {
  font-family: yekanbakh-fa;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-weight: 400;
}
@font-face {
  font-family: yekanbakh-fa;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-weight: 300;
}
@font-face {
  font-family: yekanbakh-fa;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-weight: 600;
}
@font-face {
  font-family: yekanbakh-fa;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-weight: 700;
}
@font-face {
  font-family: yekanbakh-fa;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-weight: 800;
}
@font-face {
  font-family: poppins;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-weight: 600;
}
@font-face {
  font-family: poppins;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-weight: 400;
}
:root {
  --bgBtn: linear-gradient(269deg, #fc01a9 0%, #d301a9 100%);
  --bgMore: rgba(252, 1, 169, 0.1);
  --borderMore: #ff00a8;
  --main: #ff00a8;
  --light-main: #baefd6;
  --error: red;
  --mainBg: #121a41;
  --scroll: #ff00a8;
  --bgSroll: #3e4b8b;
}
#dark {
  --background: #121a41;
  --bgFilterItem: #121a41;
  --borderFilter: #1e2754;
  --textFilter: #fff;
  --productText: #fff;
  --productTextLow: #7e84a6;
  --placeholder-main: #07062a;
  --placeholder-shadow: #292954;
  --footer-bg: #0a1133;
  --footer-text: #fff;
}
#light {
  --background: #fff;
  --borderFilter: #f5f5f5;
  --bgFilterItem: #f5f5f5;
  --textFilter: #101010;
  --productText: #fff;
  --productTextLow: #cacaca;
  --placeholder-main: #2C719D;
  --placeholder-shadow: #69a9d1;
  --footer-bg: #f8f8f8;
  --footer-text: #101010;
}
body {
  position: relative;
  font-family: yekanbakh-fa;
  direction: rtl;
  overflow: auto;
  overflow-x: hidden;
  -webkit-overflow-x: hidden;
  margin: 0;
  background: #fff;
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  color: #000;
  background: #2C719D;
}
.app {
}
p,
a,
button,
span,
label,
input {
  font-family: yekanbakh-fa;
  /* -moz-font-feature-settings: "ss02";
  -webkit-font-feature-settings: "ss02";
  font-feature-settings: "ss02"; */
}
a {
  text-decoration: none;
}

.container {
  /* max-width: 1000px; */
  /* margin-left: auto;
  margin-right: auto;
  padding-right: 1.5rem;
  padding-left: 1.5rem; */
}

.padding-none {
  padding: unset !important;
}

button,
a {
  cursor: pointer;
  background: none;
  border: none;
  font-family: yekanbakh-fa;
}

input {
  font-family: yekanbakh-fa;
  outline: 0;
}
.hover-opacity-8:hover {
  transition: all 0.1s ease-in-out;
  opacity: 0.8;
}
img {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  /* Konqueror HTML */
  /* Old versions of Firefox */
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
  supported by Chrome, Opera and Firefox */
  max-width: 100%;
}

::-webkit-scrollbar {
  width: 2px;
}

/* Track */
::-webkit-scrollbar-track {
  /* background: rgba(255, 255, 255, 0.1); */

  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #fff;

  border-radius: 10px;
}

/*---------------------------------------------------------------
  # Layout
-----------------------------------------------------------------*/
.hidden-input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}
.w-frame {
  width: 320px;
  border-radius: 8px;
}
.d-none {
  display: none !important;
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-col {
  flex-direction: column;
}
.flex-row {
  flex-direction: row;
}
.hidden {
  opacity: 0;
  visibility: hidden;
}

.flex {
  display: flex;
}

.block {
  display: block;
}
.inline {
  display: inline;
}
.no-scroll {
  overflow-y: hidden;
}
.mobile {
  display: flex !important;
}
.desktop {
  display: none !important;
}
.disable {
  pointer-events: none;
}

.w-full {
  width: 100%;
}

.w-50 {
  width: 50%;
}
.img-frame {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

@media screen and (min-width: 1200px) {
  .mobile {
    display: none !important;
  }
  .desktop {
    display: flex !important;
  }
  body {
    /* background-image: url("../img/background/bg-desktop.jpg"); */
    background-size: cover;
  }
  .hover {
    transition: all 0.1s ease-in-out;
    cursor: pointer;
  }
  .hover:hover {
    opacity: 0.8 !important;
  }
}
/*---------------------------------------------------------------
  # Z-Index
-----------------------------------------------------------------*/
.z-0 {
  z-index: 0;
}
.z-100 {
  z-index: 100;
}
.z-200 {
  z-index: 200;
}
.z-300 {
  z-index: 300;
}
.z-400 {
  z-index: 400;
}
.z-500 {
  z-index: 500;
}
.z-600 {
  z-index: 600;
}
.z-700 {
  z-index: 700;
}
.z-800 {
  z-index: 800;
}
.z-900 {
  z-index: 900;
}
/*---------------------------------------------------------------
  #  position
-----------------------------------------------------------------*/
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
/*---------------------------------------------------------------
  #  margin
-----------------------------------------------------------------*/
.m-t-9 {
  margin-top: 9px;
}
.m-t-4 {
  margin-top: 4px;
}
.m-t {
  margin-top: unset;
}
.m-b {
  margin-bottom: unset;
}
/*---------------------------------------------------------------
  #  colors
-----------------------------------------------------------------*/
.white {
  color: #fff !important;
}
.red {
  color: #c1272d;
}
.green {
  color: #1b6e48;
}
.blue {
  color: #32327f;
}
/*---------------------------------------------------------------
  #  defulat 
-----------------------------------------------------------------*/
.swiper-button-next,
.swiper-button-prev {
  display: none !important;
}
@media screen and (min-width: 1200px) {
  .swiper-button-next,
  .swiper-button-prev {
    display: flex !important;
    width: 40px !important;
    height: 40px !important;
    border-radius: 33px !important;
  }
  .swiper-button-next::after,
  .swiper-button-prev::after {
    content: "prev";
    font-size: 22px !important;
    color: #fff !important;
  }
  .swiper-button-prev.swiper-button-disabled,
  .swiper-button-next.swiper-button-disabled {
    pointer-events: unset !important;
  }
}
.swiper-pagination-bullet-active {
  background: #47ad92 !important;
  width: 4px !important;
  height: 4px !important;
  transform: rotate(-45deg) !important;
  border-radius: unset !important;
}
.swiper-pagination-bullet {
  width: 4px !important;
  height: 4px !important;
  transform: rotate(-45deg) !important;
  border-radius: unset !important;
}
@media (min-width: 1024px) {

  .lg\\:\\!w-96 {
    width: 24rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style/globals.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AACnB;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,6CAA6C;AAC/C;AACA;EACE,yBAAyB;EACzB,4CAAwE;EACxE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,4CAAsE;EACtE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,4CAAyE;EACzE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,4CAAqE;EACrE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,4CAA0E;EAC1E,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,4CAA8D;EAC9D,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,4CAA+D;EAC/D,gBAAgB;AAClB;AACA;EACE,0DAA0D;EAC1D,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;AACA;AACA;AACA;;;;;;EAME,yBAAyB;EACzB;;kCAEgC;AAClC;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB;;;yBAGuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,WAAW;EAEX,mBAAmB;EAEnB,4BAA4B;EAE5B,2BAA2B;EAC3B,iBAAiB;EACjB;0CACwC;EACxC,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,0CAA0C;;EAE1C,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;;EAEhB,mBAAmB;AACrB;;AAEA;;kEAEkE;AAClE;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,+DAA+D;IAC/D,sBAAsB;EACxB;EACA;IACE,gCAAgC;IAChC,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;;kEAEkE;AAClE;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;;kEAEkE;AAClE;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;kEAEkE;AAClE;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;;kEAEkE;AAClE;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;kEAEkE;AAClE;;EAEE,wBAAwB;AAC1B;AACA;EACE;;IAEE,wBAAwB;IACxB,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;EAChC;EACA;;IAEE,eAAe;IACf,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;;IAEE,gCAAgC;EAClC;AACF;AACA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;EACtB,oCAAoC;EACpC,+BAA+B;AACjC;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oCAAoC;EACpC,+BAA+B;AACjC;AA7XA;;EAAA;IAAA;EA8XA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n@font-face {\n  font-family: yekanbakh-fa;\n  src: url(../../public/assets/fonts/yekanbakh/YekanBakhFaNum-Regular.ttf);\n  font-weight: 400;\n}\n@font-face {\n  font-family: yekanbakh-fa;\n  src: url(../../public/assets/fonts/yekanbakh/YekanBakhFaNum-Light.ttf);\n  font-weight: 300;\n}\n@font-face {\n  font-family: yekanbakh-fa;\n  src: url(../../public/assets/fonts/yekanbakh/YekanBakhFaNum-SemiBold.ttf);\n  font-weight: 600;\n}\n@font-face {\n  font-family: yekanbakh-fa;\n  src: url(../../public/assets/fonts/yekanbakh/YekanBakhFaNum-Bold.ttf);\n  font-weight: 700;\n}\n@font-face {\n  font-family: yekanbakh-fa;\n  src: url(../../public/assets/fonts/yekanbakh/YekanBakhFaNum-ExtraBold.ttf);\n  font-weight: 800;\n}\n@font-face {\n  font-family: poppins;\n  src: url(../../public/assets/fonts/poppins/Poppins-Medium.ttf);\n  font-weight: 600;\n}\n@font-face {\n  font-family: poppins;\n  src: url(../../public/assets/fonts/poppins/Poppins-Regular.ttf);\n  font-weight: 400;\n}\n:root {\n  --bgBtn: linear-gradient(269deg, #fc01a9 0%, #d301a9 100%);\n  --bgMore: rgba(252, 1, 169, 0.1);\n  --borderMore: #ff00a8;\n  --main: #ff00a8;\n  --light-main: #baefd6;\n  --error: red;\n  --mainBg: #121a41;\n  --scroll: #ff00a8;\n  --bgSroll: #3e4b8b;\n}\n#dark {\n  --background: #121a41;\n  --bgFilterItem: #121a41;\n  --borderFilter: #1e2754;\n  --textFilter: #fff;\n  --productText: #fff;\n  --productTextLow: #7e84a6;\n  --placeholder-main: #07062a;\n  --placeholder-shadow: #292954;\n  --footer-bg: #0a1133;\n  --footer-text: #fff;\n}\n#light {\n  --background: #fff;\n  --borderFilter: #f5f5f5;\n  --bgFilterItem: #f5f5f5;\n  --textFilter: #101010;\n  --productText: #fff;\n  --productTextLow: #cacaca;\n  --placeholder-main: #2C719D;\n  --placeholder-shadow: #69a9d1;\n  --footer-bg: #f8f8f8;\n  --footer-text: #101010;\n}\nbody {\n  position: relative;\n  font-family: yekanbakh-fa;\n  direction: rtl;\n  overflow: auto;\n  overflow-x: hidden;\n  -webkit-overflow-x: hidden;\n  margin: 0;\n  background: #fff;\n  background-size: cover;\n  background-repeat: no-repeat;\n  height: 100%;\n  color: #000;\n  background: #2C719D;\n}\n.app {\n}\np,\na,\nbutton,\nspan,\nlabel,\ninput {\n  font-family: yekanbakh-fa;\n  /* -moz-font-feature-settings: \"ss02\";\n  -webkit-font-feature-settings: \"ss02\";\n  font-feature-settings: \"ss02\"; */\n}\na {\n  text-decoration: none;\n}\n\n.container {\n  /* max-width: 1000px; */\n  /* margin-left: auto;\n  margin-right: auto;\n  padding-right: 1.5rem;\n  padding-left: 1.5rem; */\n}\n\n.padding-none {\n  padding: unset !important;\n}\n\nbutton,\na {\n  cursor: pointer;\n  background: none;\n  border: none;\n  font-family: yekanbakh-fa;\n}\n\ninput {\n  font-family: yekanbakh-fa;\n  outline: 0;\n}\n.hover-opacity-8:hover {\n  transition: all 0.1s ease-in-out;\n  opacity: 0.8;\n}\nimg {\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari */\n  -khtml-user-select: none;\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Old versions of Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  /* Non-prefixed version, currently\n  supported by Chrome, Opera and Firefox */\n  max-width: 100%;\n}\n\n::-webkit-scrollbar {\n  width: 2px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  /* background: rgba(255, 255, 255, 0.1); */\n\n  border-radius: 10px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #fff;\n\n  border-radius: 10px;\n}\n\n/*---------------------------------------------------------------\n  # Layout\n-----------------------------------------------------------------*/\n.hidden-input {\n  position: absolute;\n  opacity: 0;\n  z-index: -1;\n}\n.w-frame {\n  width: 320px;\n  border-radius: 8px;\n}\n.d-none {\n  display: none !important;\n}\n.flex-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n.flex-row {\n  flex-direction: row;\n}\n.hidden {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.flex {\n  display: flex;\n}\n\n.block {\n  display: block;\n}\n.inline {\n  display: inline;\n}\n.no-scroll {\n  overflow-y: hidden;\n}\n.mobile {\n  display: flex !important;\n}\n.desktop {\n  display: none !important;\n}\n.disable {\n  pointer-events: none;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.w-50 {\n  width: 50%;\n}\n.img-frame {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n@media screen and (min-width: 1200px) {\n  .mobile {\n    display: none !important;\n  }\n  .desktop {\n    display: flex !important;\n  }\n  body {\n    /* background-image: url(\"../img/background/bg-desktop.jpg\"); */\n    background-size: cover;\n  }\n  .hover {\n    transition: all 0.1s ease-in-out;\n    cursor: pointer;\n  }\n  .hover:hover {\n    opacity: 0.8 !important;\n  }\n}\n/*---------------------------------------------------------------\n  # Z-Index\n-----------------------------------------------------------------*/\n.z-0 {\n  z-index: 0;\n}\n.z-100 {\n  z-index: 100;\n}\n.z-200 {\n  z-index: 200;\n}\n.z-300 {\n  z-index: 300;\n}\n.z-400 {\n  z-index: 400;\n}\n.z-500 {\n  z-index: 500;\n}\n.z-600 {\n  z-index: 600;\n}\n.z-700 {\n  z-index: 700;\n}\n.z-800 {\n  z-index: 800;\n}\n.z-900 {\n  z-index: 900;\n}\n/*---------------------------------------------------------------\n  #  position\n-----------------------------------------------------------------*/\n.static {\n  position: static;\n}\n.fixed {\n  position: fixed;\n}\n.absolute {\n  position: absolute;\n}\n.relative {\n  position: relative;\n}\n.sticky {\n  position: sticky;\n}\n/*---------------------------------------------------------------\n  #  margin\n-----------------------------------------------------------------*/\n.m-t-9 {\n  margin-top: 9px;\n}\n.m-t-4 {\n  margin-top: 4px;\n}\n.m-t {\n  margin-top: unset;\n}\n.m-b {\n  margin-bottom: unset;\n}\n/*---------------------------------------------------------------\n  #  colors\n-----------------------------------------------------------------*/\n.white {\n  color: #fff !important;\n}\n.red {\n  color: #c1272d;\n}\n.green {\n  color: #1b6e48;\n}\n.blue {\n  color: #32327f;\n}\n/*---------------------------------------------------------------\n  #  defulat \n-----------------------------------------------------------------*/\n.swiper-button-next,\n.swiper-button-prev {\n  display: none !important;\n}\n@media screen and (min-width: 1200px) {\n  .swiper-button-next,\n  .swiper-button-prev {\n    display: flex !important;\n    width: 40px !important;\n    height: 40px !important;\n    border-radius: 33px !important;\n  }\n  .swiper-button-next::after,\n  .swiper-button-prev::after {\n    content: \"prev\";\n    font-size: 22px !important;\n    color: #fff !important;\n  }\n  .swiper-button-prev.swiper-button-disabled,\n  .swiper-button-next.swiper-button-disabled {\n    pointer-events: unset !important;\n  }\n}\n.swiper-pagination-bullet-active {\n  background: #47ad92 !important;\n  width: 4px !important;\n  height: 4px !important;\n  transform: rotate(-45deg) !important;\n  border-radius: unset !important;\n}\n.swiper-pagination-bullet {\n  width: 4px !important;\n  height: 4px !important;\n  transform: rotate(-45deg) !important;\n  border-radius: unset !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
